import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Popover } from 'antd';

// assets
import Arrow from '../../../../../assets/customSVG/Arrow';

// hooks
import useToggle from '../../../../../hooks/useToggle';

// helper
import { cn } from '../../../../../helper/cn';
import { isObjectEmpty } from '../../../helpers';

// components
import Switch from '../../../../../components/commonComponents/step/switch';

const messageTypes = [
  { id: 1, label: 'Repeat this message', key: 'REPEAT_MESSAGE' },
  { id: 2, label: 'Send error message', key: 'ERROR_MESSAGE' },
];

const maxReplayTextLimit = 160;

const DefaultReplay = ({ nodeId, data, onChange }) => {
  const textareaRef = useRef();
  const [isChecked, setIsChecked] = useToggle(false);
  const [isPopupOpen, setIsPopupOpen] = useToggle(false);
  const [selectedReplaymessage, setSelectedReplaymessage] = useState(null);

  useEffect(() => {
    if (data) {
      const selectedReply =
        data?.type === 'compose' ? messageTypes?.[1] : messageTypes?.[0];
      setSelectedReplaymessage(selectedReply);
      setIsChecked(true);
    } else if (isObjectEmpty(data) || !data) {
      setSelectedReplaymessage(messageTypes?.[0]);
    } else {
      setIsChecked(false);
    }
  }, []);

  const toggleSwitch = () => {
    if (!isChecked) {
      onChange({
        type: 'UPDATE_NODE_REPLY',
        id: nodeId,
        key: 'REPEAT_MESSAGE',
        data: {
          body: '',
          type: 'repeat',
        },
      });
    } else {
      onChange({
        type: 'UPDATE_NODE_REPLY',
        id: nodeId,
        key: 'NONE',
        data: {},
      });
    }
    setIsChecked(!isChecked);
  };

  const handleSelectMessageType = ({ type }) => {
    onChange({
      type: 'UPDATE_NODE_REPLY',
      id: nodeId,
      key: type?.key,
      data: {
        body: '',
        type: type?.key === 'ERROR_MESSAGE' ? 'compose' : 'repeat',
      },
    });
    setSelectedReplaymessage(type);
    setIsPopupOpen(false);
  };

  const totalTextCount = useCallback(() => {
    if (!data?.body) return 0;
    return data?.body?.length || 0;
  }, [data?.body]);

  return (
    <div className='mb-6'>
      <div className='w-full flex flex-1 items-center gap-5'>
        <Switch
          isChecked={isChecked}
          toggleSwitch={toggleSwitch}
        />
        <div
          className={cn(
            'text-xs weight-medium flex flex-1 items-center gap-1',
            isChecked
              ? 'opacity-100 cursor-default'
              : 'opacity-50 cursor-not-allowed'
          )}>
          <p>If replied other answers</p>
          <Popover
            trigger={['click']}
            open={isPopupOpen}
            onOpenChange={(open) => {
              if (isChecked) setIsPopupOpen(open);
            }}
            content={
              <div className='min-w-52 flex flex-col p-1'>
                {messageTypes?.map((t) => {
                  return (
                    <div
                      className='h-9 flex items-center justify-center cursor-pointer border-b border-gray-100 last:border-b-0'
                      onClick={() => {
                        handleSelectMessageType({ type: t });
                      }}>
                      {t?.label}
                    </div>
                  );
                })}
              </div>
            }>
            <div
              className={cn(
                'text-[#6940F2] weight-semibold flex items-center gap-2.5 px-1.5 py-0.5 rounded transition-all ease-linear duration-200',
                isPopupOpen && 'bg-[var(--BG-50)]',
                isChecked
                  ? 'cursor-pointer hover:bg-[var(--BG-50)]'
                  : 'cursor-not-allowed'
              )}
              onClick={() => {
                if (isChecked) setIsPopupOpen(!isPopupOpen);
              }}>
              <p>{selectedReplaymessage?.label}</p>
              <Arrow
                width={8}
                height={8}
                color={isChecked ? '#6940F2' : '#6940F2'}
                className={cn(
                  'transition-all ease-linear duration-200',
                  isPopupOpen ? 'rotate-90' : '-rotate-90'
                )}
              />
            </div>
          </Popover>
        </div>
      </div>
      {data && selectedReplaymessage?.key === 'ERROR_MESSAGE' && (
        <div className='py-2.5'>
          <label className='pb-2.5 text-xs weight-semibold'>
            Error Message
          </label>
          <div className='border border-[var(--border-100)] rounded-md'>
            <textarea
              className='w-full h-14 resize-none bg-transparent text-xs weight-medium px-2.5 py-1.5 outline-none'
              placeholder={"Sorry, I didn't understand that. Please try again."}
              value={data?.body}
              ref={textareaRef}
              onClick={(e) => textareaRef?.current?.focus()}
              maxLength={maxReplayTextLimit}
              onChange={(e) => {
                onChange({
                  type: 'UPDATE_NODE_REPLY',
                  id: nodeId,
                  key: selectedReplaymessage?.key,
                  data: {
                    body: e.target.value,
                    type:
                      selectedReplaymessage?.key === 'REPEAT_MESSAGE'
                        ? 'repeat'
                        : 'compose',
                  },
                });
              }}
            />
            <div className='w-auto h-5 px-2.5 flex items-center justify-end text-[0.688rem] weight-semibold text-[#898E99]'>
              {totalTextCount()}/{maxReplayTextLimit}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DefaultReplay;
